import type { GameViewModel } from '../game/runtime-state';
import { EXTREME_PAID_SPINS } from '../extreme/types';
import type { AppViewModel, StatusTone } from '../ui';

function statusFor(view: GameViewModel): { readonly message: string; readonly tone: StatusTone } {
  switch (view.phase) {
    case 'spinning':
      return { message: 'Die Karten des Schicksals werden aufgedeckt …', tone: 'neutral' };
    case 'recovering':
      return { message: 'Ein sicher gespeichertes Duell wird wiederhergestellt …', tone: 'bonus' };
    case 'feature-intro':
      return { message: 'Das Millennium-Puzzle öffnet die Freispielkammer.', tone: 'bonus' };
    case 'feature-ready':
      return { message: 'Freispiele bereit. Auto ist aus.', tone: 'bonus' };
    case 'feature-summary':
      return { message: 'Das Feature ist beendet. Dein Ergebnis wird enthüllt.', tone: 'bonus' };
    case 'extreme-summary':
      return { message: `${EXTREME_PAID_SPINS} Duelle vollendet. Dein Extreme-Ergebnis ist bereit.`, tone: 'bonus' };
    case 'idle':
      return view.lastWinCents > 0
        ? { message: 'Gewinn verbucht. Das nächste Duell wartet.', tone: 'win' }
        : { message: 'Der Tempel wartet auf dein Duell.', tone: 'neutral' };
  }
}

export function toAppViewModel(view: GameViewModel, ready = true): AppViewModel {
  const status = statusFor(view);
  const ranked = view.rankedRun;
  const extreme = view.extremeRun;
  const feature = view.bonus === null ? null : Object.freeze({
    remainingSpins: view.bonus.remainingSpins,
    stickyCount: view.bonus.stickyWilds.length,
    totalWinCents: view.bonus.totalWinCents,
  });
  const interactionLocked = view.phase === 'spinning'
    || view.phase === 'recovering'
    || view.phase === 'feature-intro'
    || view.phase === 'feature-summary'
    || view.phase === 'extreme-summary';
  return Object.freeze({
    ready,
    balanceCents: view.balanceCents,
    betCents: view.betCents,
    lastWinCents: view.lastWinCents,
    gameMode: extreme !== null ? 'extreme' : ranked === null ? 'normal' : 'ranked',
    presentationMode: view.presentationMode,
    auto: view.autoEnabled,
    turbo: view.turbo,
    spinning: view.phase === 'spinning' || view.phase === 'recovering',
    interactionLocked,
    canSpin: ready && view.canSpin,
    canChangeBet: ready && view.canChangeBet,
    status: status.message,
    statusTone: status.tone,
    feature,
    rankedRun: ranked,
    extremeRun: extreme,
  });
}
